import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import JobPage from './pages/JobPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/carrieres/technico-commercial" element={<JobPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
